<template>
  <v-container>
    <h2 style="color:gray">Cài đặt hệ thống</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-setting-group"
          :label="'Cho phép ' + roleName + ' quản trị hệ thống'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-staff-list"
          :label="'Cho phép ' + roleName + ' xem danh sách người dùng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox
      ></v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-staff"
          :label="'Cho phép ' + roleName + ' thêm mới người dùng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-staff"
          :label="'Cho phép ' + roleName + ' sửa thông tin người dùng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-staff"
          :label="'Cho phép ' + roleName + ' xóa người dùng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="config-roles"
          :label="'Cho phép ' + roleName + ' thiết lập phân quyền'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox
      ></v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
